import { render, staticRenderFns } from "./StdLoginView.vue?vue&type=template&id=620ea7af&scoped=true&"
import script from "./StdLoginView.vue?vue&type=script&lang=js&"
export * from "./StdLoginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ea7af",
  null
  
)

export default component.exports